import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateState',
})
export class TranslateStatePipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string | number): string {
    value = value?.toString();

    if (value && this.customTranslationsService.ON_OFF_STATES[value.toLowerCase()]) {
      return this.translateService.instant(
        this.customTranslationsService.ON_OFF_STATES[value.toLowerCase()] ?? value
      );
    }

    return value;
  }
}
